export const ContactsTestIds = {
  SEARCH: 'telephony-contacts.search-input',
};
